















import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class BirthYearMonthPicker extends Vue {
  @Prop() year!: string
  @Prop() month!: string
  @Prop() print!: boolean

  get birthday() {
    if (this.year !== '' && this.month !== '') {
      return `${this.year}-${this.month}`
    } else {
      return null
    }
  }

  set birthday(date) {
    if (date) {
      const [year, month] = date.split('-')
      this.updateValue(year, month)
    } else {
      this.updateValue('', '')
    }
  }

  updateValue(year: string, month: string) {
    this.$emit('update:year', year)
    this.$emit('update:month', month)
  }
}
